"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertThousands = void 0;
var formatPoints = function (dividend, divider, sign) {
    var result = "".concat((dividend / divider).toFixed(1));
    return result.replace(/\.0$/, '') + sign;
};
var convertThousands = function (points) {
    var pointsInNumber = Math.abs(Number(points));
    var billion = 1.0e9;
    var million = 1.0e6;
    var thousand = 1.0e3;
    if (pointsInNumber >= billion)
        return formatPoints(pointsInNumber, billion, 'B');
    if (pointsInNumber >= million)
        return formatPoints(pointsInNumber, million, 'M');
    if (pointsInNumber >= thousand)
        return formatPoints(pointsInNumber, thousand, 'K');
    return String(pointsInNumber);
};
exports.convertThousands = convertThousands;
